import React, { useEffect, useState } from "react";
import { EditBlockOption } from "../EditBlock";
import {
    OptionIsRight,
    OptionType,
    TopicType
} from "../../../../../service/homework";
import _ from "underscore";
import { EditPanDuanPure } from "../../../../exam/addExam/components/EditPanDuan";
import { EditBlock } from "../EditBlock";
import { QuestionType } from "../../../../../service/service";

interface EditPanDuanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditPanDuan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditPanDuanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);
    const [options, setOptions] = useState<OptionType[]>(topic.answers);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic, options]);

    const onCheckChange = (index: number) => {
        const answers = options.map((item, itemIndex) => ({
            ...item,
            isRight:
                itemIndex === index ? OptionIsRight.Right : OptionIsRight.Wrong
        }));

        setOptions(answers);
        setInnerTopic({ ...innerTopic, answers });
    };

    const getValue = () => {
        return _.findIndex(options, { isRight: OptionIsRight.Right });
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.PanDuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditPanDuanPure
                onCheckChange={onCheckChange}
                getValue={getValue}
                options={options}
            />
        </EditBlock>
    );
}
